import Vue from 'vue';
import VueI18n from 'vue-i18n';
import loadLocaleMessages, {loadTenantLocaleMessages} from '@shared_utils/loadLocaleMessage';

Vue.use(VueI18n);


const i18n = new VueI18n({
    locale: process.env.VUE_APP_I18N_LOCALE || 'ko', //'ch'
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'ko', //'ko'
    silentTranslationWarn: true,
    messages: loadLocaleMessages()
});

// 테넌트 로케일은 비동기 병합 — 로그인 대문은 tenant.js i18nOverrides(동기)가 이미 처리
loadTenantLocaleMessages(i18n);

export default i18n;
